import { post, put, get } from "../../helpers/apihelpers";

export const CreateCityListService=async(data)=>{
    try {
        const result = await post(`api/admin/city_list/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateCityListService=async(data,id)=>{
    try {
        const result = await put(`api/admin/city_list/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetCityListService = async ()=>{
  try {
    const result = await get(`api/admin/city_list/get`);
    return result;
  } catch (err) {
    return err.response;
  }
}